import {
    CREATE_PERMISSION,
    READ_PERMISSION,
    UPDATE_PERMISSION,
    MAINTENANCE_PACKAGE_AUTH,
} from 'src/constants/permissions';
import { PermissionsGuard } from './components';
import { MaintenancePackageList } from 'src/views/maintenancePackage/MaintenancePackageListView';
import { MaintenancePackageDetails } from 'src/views/maintenancePackage/MaintenancePackageDetailsView';
import { CreateMaintenancePackage } from 'src/views/maintenancePackage/CreateMaintenancePackageListView';
import { UpdateMaintenancePackage } from 'src/views/maintenancePackage/UpdateMaintenancePackageListView';

export const Routes = [
    {
        exact: true,
        path: '/create/maintenance-package',
        guard: PermissionsGuard,
        roles: {
            permission: MAINTENANCE_PACKAGE_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: CreateMaintenancePackage,
    },
    {
        exact: true,
        path: '/management/maintenance-packages/:maintenancePackageId',
        guard: PermissionsGuard,
        roles: {
            permission: MAINTENANCE_PACKAGE_AUTH,
            crud: READ_PERMISSION,
        },
        component: MaintenancePackageDetails,
    },
    {
        exact: true,
        path: '/management/maintenance-packages/:maintenancePackageId/edit',
        guard: PermissionsGuard,
        roles: {
            permission: MAINTENANCE_PACKAGE_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: UpdateMaintenancePackage,
    },
    {
        exact: true,
        path: '/management/maintenance-packages',
        guard: PermissionsGuard,
        roles: {
            permission: MAINTENANCE_PACKAGE_AUTH,
            crud: READ_PERMISSION,
        },
        component: MaintenancePackageList,
    },
];
